export const environment = {
  production: true,
  apiUrl: 'https://p2p-api.paynet.md',
  oplatamdURL: 'https://oplata.md',
  pspURL: 'https://psp.paynet.md',
  RECAPTCHA_SITE_KEY: '6LeIbRUnAAAAAPtndZrRUndlAaxbNZQnj3RQRIEG',
};
